import React, { useContext, useState } from 'react';
import './ProductDetails.css';
import { ShopContext } from '../../Context/ShopContext';
import { useNavigate } from 'react-router-dom';

// Placeholder data
const placeholderProduct = {
    id: "sample-product-id",  // Ensure the productId field is present
    name: "Sample Product",
    images: [
        "https://via.placeholder.com/600x400.png?text=Sample+Product+Image",  // Example placeholder image
        "https://via.placeholder.com/600x400.png?text=Sample+Product+Image+2"  // Another example image
    ],  // Now an array of image URLs
    colors: ["#ff0000", "#00ff00", "#0000ff"], // Red, Green, Blue
    description: "This is a placeholder description for the sample product. It provides a brief overview of the item's features and benefits.",
    new_price: "49.99",
    old_price: "79.99",
    quantity: "1",
    sizes: [
        { size_name: "Small", dimensions: { length: 10, width: 10, height: 5 } },
        { size_name: "Medium", dimensions: { length: 20, width: 20, height: 10 } },
        { size_name: "Large", dimensions: { length: 30, width: 30, height: 15 } },
        { size_name: "Extra Large", dimensions: { length: 40, width: 40, height: 20 } }
    ],
};

// Helper function to format dimensions object into a readable string
const formatDimensions = (dimensions) => {
    return `${dimensions.length}x${dimensions.width}x${dimensions.height} cm`;
};

const ProductDetails = ({ product = placeholderProduct, onClose }) => {
    const { addToCart } = useContext(ShopContext);
    const [selectedSize, setSelectedSize] = useState({
        name: "DIMENSIONS", 
        dimensions: "Not Specified"
    });
    const [selectedColor, setSelectedColor] = useState(null); // Track selected color
    const [quantity, setQuantity] = useState(1); // Track quantity input
    const [isOverviewOpen, setIsOverviewOpen] = useState(true); // State for toggling overview
// ✅ Track Current Image
const [currentImageIndex, setCurrentImageIndex] = useState(0);
    
// ✅ Ensure images array is valid
const images = Array.isArray(product.images) && product.images.length > 0 
    ? product.images 
    : (product.image ? [product.image] : []);

const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
};

const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
};

    const handleSizeChange = (event) => {
        const selectedName = event.target.value;
        const size = product.sizes.find(size => size.size_name === selectedName);

        if (size) {
            setSelectedSize({
                name: selectedName,
                dimensions: formatDimensions(size.dimensions),
            });
        } else {
            console.log('No size found for the selected name:', selectedName);
        }
    };

    const handleColorChange = (color) => {
        setSelectedColor(color); // Update the selected color
    };

    const handleQuantityChange = (event) => {
        const value = Math.max(1, parseInt(event.target.value, 10) || 1);
        setQuantity(value);
    };

    const navigate = useNavigate();

    const handleAddToCart = () => {
        console.log("Product being added to cart:", product); 
        const authToken = localStorage.getItem("auth-token"); // Check for auth-token

        if (!authToken) {
            alert("Please login to use the cart.");
            navigate("/login");
            return;
        }

        if (!selectedColor) {
            alert("Please select a color before adding to cart.");
        } else if (selectedSize.name === "DIMENSIONS") {
            alert("Please select a size before adding to cart.");
        } else if (!product._id) {
            alert("Invalid product. Could not add to cart.");
        } else {


            // Check if the requested quantity exceeds the available stock
            if (quantity > product.quantity) {
                alert(`Only ${product.quantity} items available in stock. Please adjust your quantity.`);
                return;
            }

            const cart = JSON.parse(localStorage.getItem("guestCart")) || { cartData: [] };  // Default to empty cartData if no cart exists
    
            // Prepare the complete product object to store in the cart
            const newItem = {
                productId: product._id,
                name: product.name,
                price: product.new_price,
                quantity,
                size: selectedSize.name,
                color: selectedColor,
                images: product.images,
                description: product.description
            };
    
            // Add the new product to the cartData array
            cart.cartData.push(newItem);  // Append to the cartData array
    
            // Save the updated cartData back to localStorage
            localStorage.setItem("guestCart", JSON.stringify(cart));
    
            // Optionally: Update the context or state with the newly added item
            addToCart(product._id, quantity, selectedSize.name, selectedColor);
    
            alert(`${quantity} x ${product.name} in ${selectedSize.name} has been added to your cart!`);
        }
    };

    const toggleOverview = () => {
        setIsOverviewOpen(!isOverviewOpen);
    };

    const hasSizes = Array.isArray(product.sizes) && product.sizes.length > 0;

    return (
        <div className="product-details-container">
            <div className="product-details-content">

                {/* ✅ Image Navigation */}
                <div className="product-image-container">
                    <button className="close-product-button" onClick={onClose}>X</button>
                    <div className="image-carousel">
                        <button onClick={prevImage} className="arrow-btn" disabled={images.length <= 1}>&#10094;</button>
                        <img src={images[currentImageIndex]} alt={product.name} className="product-image" />
                        <button onClick={nextImage} className="arrow-btn" disabled={images.length <= 1}>&#10095;</button>
                    </div>


                        {/* ✅ Blue Circle Navigation Buttons */}
                        <div className="image-nav-buttons">
                        {images.map((_, index) => (
                            <button 
                                key={index} 
                                className={`nav-dot ${currentImageIndex === index ? "active" : ""}`}
                                onClick={() => setCurrentImageIndex(index)}
                            ></button>
                        ))}
                    </div>
                </div>

                <div className="product-info">
                    <div className="product-name">{product.name}</div>

                    <div className="product-color-selector">
                        <div className="color-options">
                            {Array.isArray(product.colors) &&
                                product.colors.map((color, index) => (
                                    <div
                                        key={index}
                                        className={`color-option ${selectedColor === color ? 'selected' : ''}`}
                                        style={{ backgroundColor: color }}
                                        onClick={() => handleColorChange(color)} // Set color on click
                                    ></div>
                                ))}
                        </div>
                    </div>

                    <div className="product-prices">
                        <div className="product-price-new">${product.new_price}</div>
                        {product.new_price !== product.old_price && (
                            <div className="product-price-old">${product.old_price}</div>
                        )}
                    </div>

                    <div className="quantity-add-to-cart">
                        <div className="quantity-container">
                            <span>QTY:</span>
                            <input
                                type="number"
                                value={quantity}
                                onChange={handleQuantityChange}
                                min="1"
                                className="quantity-input"
                            />
                        </div>
                        <button onClick={handleAddToCart} className="cart-button">ADD TO CART</button>
                    </div>

                    <div className="product-dropdown">
                        <button className="custom-dropdown" onClick={toggleOverview}>
                            {isOverviewOpen ? 'Overview' : 'Overview'}
                            <span className={`caret ${isOverviewOpen ? 'up' : 'down'}`}></span>
                        </button>
                        {isOverviewOpen && (
    <div className="product-description-container">
        <p className="product-description">{product.description}</p>
    </div>
)}


                        
    <select
        value={selectedSize.name}
        onChange={handleSizeChange}
        className={`custom-dropdown ${selectedSize.name !== "DIMENSIONS" ? 'open' : ''}`}  // Apply open class based on size change
        disabled={!hasSizes}
        
    >
        
        <option value="DIMENSIONS">DIMENSIONS
            
        </option>
        
        {hasSizes ? (
            product.sizes.map((size, index) => (
                <option key={index} value={size.size_name}>
                    {size.size_name} - {formatDimensions(size.dimensions)}
                </option>
            ))
        ) : (
            <option disabled>No sizes available</option>
        )}
        
    </select>
</div>



                </div>
            </div>
        </div>
    );
};

export default ProductDetails;
